<script>
  import { onMount } from 'svelte';
  import { Chart, registerables } from 'chart.js';

  let { summary } = $props();
  let canvas;
  let chart;

  onMount(() => {
    Chart.register(...registerables);

    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  });

  // Re-render chart when summary changes or canvas is available
  $effect(() => {
    if (canvas && summary) {
      renderChart();
    }
  });

  function renderChart() {
    // Guard: Check if summary has required data
    if (!summary || !summary.byMonth || !canvas) {
      return;
    }

    // Destroy existing chart before creating new one
    if (chart) {
      chart.destroy();
      chart = null;
    }

    // Also check if Chart.js has an existing chart instance for this canvas
    const existingChart = Chart.getChart(canvas);
    if (existingChart) {
      existingChart.destroy();
    }

    // Sort months chronologically
    const months = Object.keys(summary.byMonth).sort();

    const incomeData = months.map(month => summary.byMonth[month].income);
    const expenseData = months.map(month => summary.byMonth[month].expenses);

    // Format month labels (e.g., "2026-01" -> "Jan 2026")
    const labels = months.map(month => {
      const [year, monthNum] = month.split('-');
      const date = new Date(year, monthNum - 1);
      return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
    });

    chart = new Chart(canvas, {
      type: 'line',
      data: {
        labels,
        datasets: [
          {
            label: 'Income',
            data: incomeData,
            borderColor: 'rgb(34, 197, 94)',
            backgroundColor: 'rgba(34, 197, 94, 0.1)',
            tension: 0.4,
            fill: true,
          },
          {
            label: 'Expenses',
            data: expenseData,
            borderColor: 'rgb(239, 68, 68)',
            backgroundColor: 'rgba(239, 68, 68, 0.1)',
            tension: 0.4,
            fill: true,
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 2,
        interaction: {
          mode: 'index',
          intersect: false,
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              color: 'rgb(156, 163, 175)',
              font: {
                size: 12
              }
            }
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }
                label += new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: 'USD'
                }).format(context.parsed.y);
                return label;
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              color: 'rgb(156, 163, 175)',
              callback: function(value) {
                return '$' + value.toLocaleString();
              }
            },
            grid: {
              color: 'rgba(75, 85, 99, 0.2)'
            }
          },
          x: {
            ticks: {
              color: 'rgb(156, 163, 175)'
            },
            grid: {
              color: 'rgba(75, 85, 99, 0.2)'
            }
          }
        }
      }
    });
  }
</script>

<div class="chart-container">
  <canvas bind:this={canvas}></canvas>
</div>

<style>
  .chart-container {
    position: relative;
    width: 100%;
    height: 300px;
  }
</style>
